<template>
  <div class="xianxia-xingwei-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="geyebili single-line">
        <div class="chart-title">隔夜比例</div>
        <div class="chart-content">
          <ol>
            <li
              :class="{ current: geyebili_fenlei == 0 }"
              @click="geyebili_fenlei = 0"
            >
              全体
            </li>
            <li
              :class="{ current: geyebili_fenlei == 1 }"
              @click="geyebili_fenlei = 1"
            >
              分类1
            </li>
            <li
              :class="{ current: geyebili_fenlei == 2 }"
              @click="geyebili_fenlei = 2"
            >
              分类2
            </li>
            <li
              :class="{ current: geyebili_fenlei == 3 }"
              @click="geyebili_fenlei = 3"
            >
              分类3
            </li>
            <li
              :class="{ current: geyebili_fenlei == 4 }"
              @click="geyebili_fenlei = 4"
            >
              分类4
            </li>
            <li
              :class="{ current: geyebili_fenlei == 5 }"
              @click="geyebili_fenlei = 5"
            >
              分类5
            </li>
          </ol>
          <ul>
            <li class="yibiao1">
              <div class="bg"></div>
              <div class="pointer" ref="pointer1"></div>
              <div class="info">
                <div class="bili">
                  {{
                    geyebiliData
                      ? Math.round(
                          (geyebiliData[0].value / geyebiliData[0].total) * 100
                        )
                      : 0
                  }}%
                </div>
                <div class="name">省外游客隔夜</div>
              </div>
            </li>
            <li class="yibiao2">
              <div class="bg"></div>
              <div class="pointer" ref="pointer2"></div>
              <div class="info">
                <div class="bili">
                  {{
                    geyebiliData
                      ? Math.round(
                          (geyebiliData[1].value / geyebiliData[1].total) * 100
                        )
                      : 0
                  }}%
                </div>
                <div class="name">全部游客隔夜</div>
              </div>
            </li>
            <li class="yibiao3">
              <div class="bg"></div>
              <div class="pointer" ref="pointer3"></div>
              <div class="info">
                <div class="bili">
                  {{
                    geyebiliData
                      ? Math.round(
                          (geyebiliData[2].value / geyebiliData[2].total) * 100
                        )
                      : 0
                  }}%
                </div>
                <div class="name">省内游客隔夜</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="tingliushijian single-line">
        <div class="chart-title">游客出游时间</div>
        <div class="chart-content">
          <ol>
            <li
              :class="{ current: tingliushijian_fenlei == 0 }"
              @click="tingliushijian_fenlei = 0"
            >
              综合停留
            </li>
            <li
              :class="{ current: tingliushijian_fenlei == 1 }"
              @click="tingliushijian_fenlei = 1"
            >
              年龄对比
            </li>
            <li
              :class="{ current: tingliushijian_fenlei == 2 }"
              @click="tingliushijian_fenlei = 2"
            >
              周边对比
            </li>
          </ol>
          <StackBar2 id="tingliushijian" :chartData="tingliushijianData" />
        </div>
      </div>
      <div class="jiaotongfangshi single-line">
        <div class="chart-title">游客交通方式分析</div>
        <div class="chart-content">
          <JiaotongFangshi
            id="jiaotongfangshi"
            :chartData="JiaotongFangshiData"
          />
        </div>
      </div>
      <div class="xiaofeiqianli single-line">
        <div class="chart-title">游客消费潜力分析</div>
        <div class="chart-content">
          <SingleBar id="xiaofeiqianli" :chartData="XiaofeiQianliData" />
        </div>
      </div>
      <div class="laiyuanjuli single-line">
        <div class="chart-title">游客出游距离</div>
        <div class="chart-content">
          <PolarBar
            :legendRight="210"
            id="laiyuanjuli"
            :chartData="LaiyuanJuliData"
          />
        </div>
      </div>
      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";
import StackBar2 from "@/components/Echarts/StackBar2.vue";
import JiaotongFangshi from "@/components/Echarts/JiaotongFangshi.vue";
import SingleBar from "@/components/Echarts/SingleBar.vue";
import PolarBar from "@/components/Echarts/PolarBar.vue";

export default {
  name: "ChuyouXingweiFenxiDetail",
  components: {
    ChildModal,
    StackBar2,
    JiaotongFangshi,
    SingleBar,
    PolarBar
  },
  props: {},
  data() {
    return {
      geyebiliData: "",
      geyebili_fenlei: 0,
      tingliushijian_fenlei: 1,
      tingliushijianData: null,
      cityListShow: false,
      JiaotongFangshiData: null,
      XiaofeiQianliData: null,
      LaiyuanJuliData: []
    };
  },
  mounted() {
    // 请求隔夜比例
    fetch("/data/JuminChuyou/ChuyouXingweiFenxiDetail/GeyeBili.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.geyebiliData = json.data;
        setTimeout(() => {
          var deg1 = Math.round(
            (json.data[0].value / json.data[0].total) * 180
          );
          var deg2 = Math.round(
            (json.data[1].value / json.data[1].total) * 180
          );
          var deg3 = Math.round(
            (json.data[2].value / json.data[2].total) * 180
          );
          this.$refs.pointer1.style.transform = "rotate(" + deg1 + "deg)";
          this.$refs.pointer2.style.transform = "rotate(" + deg2 + "deg)";
          this.$refs.pointer3.style.transform = "rotate(" + deg3 + "deg)";
        }, 500);
      });
    // 请求停留时间
    fetch("/data/JuminChuyou/ChuyouXingweiFenxiDetail/TingliuShijian.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        setTimeout(() => {
          this.tingliushijianData = json.data;
        }, 500);
      });
    // 请求交通方式
    fetch("/data/JuminChuyou/ChuyouXingweiFenxiDetail/JiaotongFangshi.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.JiaotongFangshiData = json.data;
      });
    // 请求消费潜力
    fetch("/data/JuminChuyou/ChuyouXingweiFenxiDetail/XiaofeiQianli.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.XiaofeiQianliData = json.data;
      });
    // 请求来源距离
    fetch("/data/JuminChuyou/ChuyouXingweiFenxiDetail/LaiyuanJuli.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.LaiyuanJuliData = json.data;
      });
  },
  methods: {
    chooseCity() {}
  }
};
</script>

<style scoped lang="less">
.geyebili {
  padding: 0 1rem;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 0.05rem !important;
  .chart-content {
    ol {
      width: 44%;
    }
    ul {
      margin: 1rem auto 0;
      position: relative;
      .yibiao1 {
        float: left;
      }
      .yibiao3 {
        float: right;
      }
      .yibiao2 {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -20%) scale(1.5);
      }
      li {
        width: 2.28rem;
        height: 2.28rem;
        position: relative;
        .info {
          margin-top: 0.12rem;
          width: 100%;
          text-align: center;
          .bili {
            color: #ff553e;
          }
        }
        .bg {
          width: 2.28rem;
          height: 1.14rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan.png)
            no-repeat;
          background-size: 100% 100%;
        }
        .pointer {
          transition: all 0.4s;
          width: 2.28rem;
          height: 2.28rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan_pointer.png)
            no-repeat;
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          left: 0;
          transform: rotate(0deg);
        }
      }
    }
  }
}
.child-detail {
  .tingliushijian {
    .chart-content {
      ol {
        width: 28%;
        li {
          width: 33.33%;
        }
      }
    }
  }
  .zhusuretu {
    .chart-content {
      height: 270px;
      width: 80%;
      ol {
        width: 100%;
        li {
          width: 8.33%;
        }
      }
    }
    .expand {
      height: 0.3rem;
      position: absolute;
      left: 1.1rem;
      top: 0.1rem;
      cursor: pointer;
      > div {
        float: left;
        height: 0.3rem;
        line-height: 0.3rem;
      }
      .local {
        width: 0.3rem;
        background: url(../../assets/youkexianxiaxingweifenxi/local.png);
        background-size: 100% 100%;
      }
      .arrow {
        width: 0.3rem;
        background: url(../../assets/header_menu/arrow.png);
        background-size: 100% 100%;
      }
      .city-list {
        position: absolute;
        left: 0;
        top: 0.3rem;
        width: 100%;
        background: #052148;
        border: 1px solid #00cdff;
        padding: 0.05rem 0;
        box-sizing: border-box;
        li:hover {
          background: #0c3964;
        }
      }
    }
  }
}
</style>
